export default __webpack_public_path__ + "static/media/icon.68c7f0f4.png";